/* Keep all six media items; omit only the selected thumbnail. */
(() => {
  const init = () => customElements.whenDefined('media-gallery').then(() => {
    const product = document.querySelector('product-info[data-product-id="11385715589447"]');
    const gallery = product?.querySelector('media-gallery');
    if (!gallery?.elements?.thumbnails || gallery.dataset.bijanGalleryReady) return;
    gallery.dataset.bijanGalleryReady = 'true';
    gallery.setActiveThumbnail = function (thumbnail) {
      if (!thumbnail) return;
      const items = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
      const hadFocus = thumbnail.contains(document.activeElement);
      items.forEach(item => {
        const current = item === thumbnail;
        const button = item.querySelector('button');
        if (current) button?.setAttribute('aria-current', 'true');
        else button?.removeAttribute('aria-current');
        item.hidden = current;
      });
      this.elements.thumbnails.resetPages?.();
      if (hadFocus) {
        const index = items.indexOf(thumbnail);
        const next = items.slice(index + 1).concat(items.slice(0, index)).find(item => !item.hidden);
        next?.querySelector('button')?.focus({ preventScroll: true });
      }
    };
    const active = gallery.elements.viewer.querySelector('[data-media-id].is-active');
    const target = active?.dataset.mediaId;
    const selected = Array.from(gallery.elements.thumbnails.querySelectorAll('[data-target]'))
      .find(item => item.dataset.target === target);
    gallery.setActiveThumbnail(selected);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
